  <div class="transaction-content pt-2">
    <div class="transaction-duration search-holder">
      <ul class="list-inline grid-top-actions mb-3">
        <li class="list-inline-item">
          <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
        </li>
        <li class="list-inline-item">
          <div class="calendar-btn">
            <input matInput [matDatepicker]="dpFrom" disabled [min]="minFromDate" placeholder="MM/DD/YYYY" [max]="maxDate"
              [formControl]="fromCntrl" (dateChange)="changeFromDate($event)" />
            <mat-datepicker-toggle matSuffix [for]="dpFrom"></mat-datepicker-toggle>
            <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
          </div>
        </li>
        <li class="list-inline-item">
          <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
        </li>
        <li class="list-inline-item">
          <div class="calendar-btn">
            <input matInput [matDatepicker]="dpTo" disabled [min]="minToDate" placeholder="MM/DD/YYYY"
              [formControl]="toCntrl" [max]="maxDate" (dateChange)="changeToDate($event)" />
            <mat-datepicker-toggle matSuffix [for]="dpTo"></mat-datepicker-toggle>
            <mat-datepicker #dpTo disabled="false"></mat-datepicker>
          </div>
        </li>
        <li class="list-inline-item ">
          <div class="search-holder">
            <input type="text" placeholder="{{ 'pages.newRetailer.search' | translate }}" matInput class="
                rounded-pill
                px-3
                py-2
                mb-0
                border-0
                bg-light
                w-100
                me-0
                input-search
                ms-3
              " (keyup)="quickSearch()" [(ngModel)]="searchValue" />
          </div>
        </li>
        <!-- <li class="list-inline-item">
                  <h4 class="transaction-dates">{{transactionFromDate}} - {{transactionToDate}}</h4>
                </li> -->
  
        <li class="list-inline-item float-lg-end">
          <button mat-stroked-button color="primary" class="" (click)="exportData()">
            <span translate class="translate">pages.newRetailer.download</span>
            <i class="mi mi-save-alt"></i>
          </button>
        </li>
  
        <li class="list-inline-item float-lg-end">
          <button mat-stroked-button (click)="onClickYear()" color="primary">
            {{ 'pages.placeholders.Thisyear' | translate }}
          </button>
        </li>
        <li class="list-inline-item float-lg-end">
          <button mat-stroked-button (click)="onClickMonth()" color="primary">
            {{ 'pages.placeholders.Thismonth' | translate }}
          </button>
        </li>
      </ul>
    </div>
    <hr />
    <div class="transactions-grid-container card p-3 mt-1 border-0">
      <ag-grid-angular style="width: 100%; height: 50vh" class="ag-theme-material" [rowHeight]="40" [enableFilter]="true"
        [enableSorting]="true" [enableColResize]="true" [rowSelection]="'single'" [rowData]="rowData"
        [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" (selectionChanged)="onSelectionChanged($event)">
      </ag-grid-angular>
    </div>
  </div>